import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { Outlet } from 'react-router-dom';

const Wrapper = styled.div`
`;

@observer
class Forum extends React.Component {

  render() {
    return (
      <Wrapper>
        <Outlet />
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Forum);
